// The native client supplies display preferences before the bundled script runs.
// These are not account credentials and never set authentication state.
export function androidEntry() {
  const entry = window.__ANTSMEETING_ENTRY__;
  if (!entry || typeof entry.name !== 'string') return null;
  const name = entry.name.trim().slice(0, 40);
  return name ? { name, language: entry.language } : null;
}

export function roomJoinPayload(roomID) {
  const entry = androidEntry();
  return entry ? { roomID, userName: entry.name } : roomID;
}

export function peerDisplayName(name) {
  return typeof name === 'string' ? name.trim().slice(0, 40) : '';
}
